export const presetQuickLinks = [];
